/**
 * Viewport-relative lengths that still apply on an old Android WebView.
 *
 * `dvh` is Chrome 108+. An engine that does not know a unit drops the whole
 * declaration, and Android 11 phones whose "Android System WebView" was never
 * updated still run Chrome 90 — the owner's own phone reports
 * `Chrome/90.0.4430.210 ... wv`. There `height: 100dvh` on the app shell was
 * `height: auto`: the shell stopped being one screen tall and the document
 * scrolled instead of the shell's scrollport, the mobile map box was left with
 * only its 300px min-height, the chat lost its height and the account sheet
 * lost the bound that keeps Log Out on screen.
 *
 * A WebView has no browser toolbar to slide away, which is the gap `dvh` was
 * made for, so `vh` is the stand-in there. The engine is asked once, and every
 * engine that knows `dvh` gets exactly the string it got before. A bare `dvh`
 * length anywhere else in src is the bug this exists to prevent;
 * viewportHeight.test.js sweeps for one.
 */
const unit =
  typeof CSS !== "undefined" && CSS.supports && CSS.supports("height", "1dvh") ? "dvh" : "vh";

/** `dvh(100)` is "100dvh", or "100vh" on an engine without `dvh`. */
export const dvh = (n) => n + unit;
